module.exports = " <a role=button class=btn v-bind:class=buttonType v-link=menuUrl> <span class=glyphicon v-bind:class=glyphIcon aria-hidden=true></span><br> <slot></slot> </a> ";


/*****************
 ** WEBPACK FOOTER
 ** /home/onlygamescl/onlygames-front/shared/~/vue-html-loader!/home/onlygamescl/onlygames-front/shared/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MenuButton.vue
 ** module id = 288
 ** module chunks = 1
 **/